/**
 * Display helpers for member-facing name/copy formatting.
 */

/**
 * Title-case a person name when the source is ALL CAPS (common from IDV).
 * Leaves already-mixed names alone (e.g. McDonald, Mary-Jane).
 */
export function formatDisplayName(value) {
  if (value == null) return '';
  const raw = String(value).trim();
  if (!raw) return '';

  const letters = raw.replace(/[^A-Za-z]/g, '');
  if (!letters) return raw;

  const isAllCaps = letters === letters.toUpperCase() && letters !== letters.toLowerCase();
  if (!isAllCaps) return raw;

  return raw
    .toLowerCase()
    .split(/([\s'-]+)/)
    .map((part) => {
      if (/^[\s'-]+$/.test(part) || !part) return part;
      return part.charAt(0).toUpperCase() + part.slice(1);
    })
    .join('');
}

/** Treat placeholder / empty instruction strings as absent. */
export function isBlankInstruction(value) {
  if (value == null) return true;
  const normalized = String(value).trim().toLowerCase();
  return !normalized || ['none', 'n/a', 'na', 'null', '-', '—'].includes(normalized);
}

/** Format a US phone number for member-facing display. */
export function formatDisplayPhone(value) {
  if (value == null) return '';
  const raw = String(value).trim();
  if (!raw) return '';
  const digits = raw.replace(/\D/g, '');
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  if (digits.length === 11 && digits.startsWith('1')) {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  return raw;
}
